var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgAuthSpiral = function SvgAuthSpiral(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 55,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.364 30.13c.3-3.054-1.405-5.156-1.945-5.663-1.049-.987-1.945-.146-2.445.387-.629.668-2.069 2.417-.739 3.667 2.116 1.99 4.99 1.622 5.129 1.608zm-3.707 6.9a11.35 11.35 0 001.912-2.716c-1.986-.541-4.032-.901-6.013-2.764-3.297-3.1-1.806-7.194.238-9.368 1.304-1.386 4.706-4.115 8.492-.555 2.123 1.996 2.596 4.34 3.207 6.393a3.685 3.685 0 001.09-.807c.33-.35.586-.743.815-1.143C46.448 8.481 32.3 4.467 35.216 1.366c.434-.462 1.347-1.307 3.529.744 9.387 8.827 3.996 23.46-.4 28.136-2.08 2.211-3.67 2.465-4.47 3.314-.807.86-1.459 3.227-4.452 6.41-7.69 8.18-19.562 8.121-21.76 6.055-.786-.74-1.123-2.177-.316-3.036 1.74-1.85 10.379 3.54 19.31-5.958z",
    fill: "#000"
  })));
};
export default SvgAuthSpiral;